module.exports = __webpack_public_path__ + "static/media/orange.6b416039.svg";